<template>
  <EditDrawer :value="value" v-on="$listeners" with-header with-footer :title="Lang.markets">
    <div class="content">
      <section class="mb-4">
        <h2 v-if="selection?.states?.length === 51">States (50 + District of Columbia)</h2>
        <h2 v-else>States ({{ selection.states.length }})</h2>
        <div class="chips">
          <v-chip v-for="(item, i) in selection.states" :key="'state-' + i" class="location-chip" small>
            {{ item }}
          </v-chip>
          <span v-if="!selection.states.length">-</span>
        </div>
      </section>

      <section class="mb-10">
        <h2>DMAs ({{ selection.dma.length }})</h2>
        <div class="chips">
          <v-chip v-for="(item, i) in preparedDma" :key="'dma-' + i" class="location-chip" small>
            {{ item }}
          </v-chip>
          <span v-if="!selection.dma.length">-</span>
        </div>
      </section>

      <section class="mb-10">
        <h2>Cities ({{ selection.cities.length }})</h2>
        <div class="chips">
          <v-chip v-for="(item, i) in selection.cities" :key="'city-' + i" class="location-chip" small>
            {{ item }}
          </v-chip>
          <span v-if="!selection.cities.length">-</span>
        </div>
      </section>

      <section class="mb-10">
        <h2>ZIP codes ({{ selection.zip_codes.length }})</h2>
        <div class="chips">
          <v-chip v-for="(item, i) in selection.zip_codes" :key="'zip-' + i" class="location-chip" small>
            {{ item }}
          </v-chip>
          <span v-if="!selection.zip_codes.length">-</span>
        </div>
      </section>
    </div>

    <template v-slot:footer>
      <div class="footer-buttons">
        <ButtonPrimary class="footer-buttons__proceed" @click="$emit('input', false)">
          {{ Lang.close }}
        </ButtonPrimary>
      </div>
    </template>
  </EditDrawer>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";

import ButtonPrimary from "@/components/customComponents/ButtonPrimary.vue";
import EditDrawer from "@/components/drawers/EditDrawer.vue";
import Lang from "@/lang";
import { dmaMap } from "@/mockData/dma";
import ROUTES from "@/settings/routes";

type LocationSelection = {
  states: string[];
  cities: string[];
  dma: string[];
  zip_codes: string[];
};

export default Vue.extend({
  name: "LocationsDrawer",
  components: { EditDrawer, ButtonPrimary },
  props: {
    value: { type: Boolean, required: true },
    selection: {
      type: Object as PropType<LocationSelection>,
      required: true,
      default: () => ({ states: [], cities: [], dma: [], zip_codes: [] }),
    },
  },
  data() {
    return {
      ROUTES,
      Lang,
    };
  },

  computed: {
    preparedDma(): string[] {
      if (!this.selection || this.selection?.dma?.length <= 0) return [];
      return this.selection.dma.map((el) => dmaMap[el] || el);
    },
  },
});
</script>

<style scoped lang="scss">
@import "@/scss/theme.scss";
@import "@/scss/custom_variables.scss";

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.block {
  margin-bottom: 20px;
}

.chips {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}

.footer-buttons {
  margin-left: auto;
  &__skip {
    margin-right: 8px;
  }
}

.location-chip {
  border-radius: 50px !important;
  background-color: var(--v-background-medium-base) !important;
  font-size: 13px;
  padding: 0 12px;
  line-height: 24px;
  height: 28px;
  display: inline-flex;
  margin: 4px 4px 4px 0;
}
</style>
